// extracted by mini-css-extract-plugin
export var Aside = "aside-module--Aside--783c3";
export var AsideWrapper = "aside-module--AsideWrapper--37575";
export var TableOfContents = "aside-module--TableOfContents--0e120";